import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y: 28 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.7, delay, ease: [0.2, 0.65, 0.3, 1] }}
  >
    {children}
  </motion.div>
);

export const SectionHead = ({ eyebrow, title, intro, testid }) => (
  <Reveal className="max-w-3xl mb-14 md:mb-20">
    <p className="eyebrow mb-5">{eyebrow}</p>
    <h2 className="h2-epl" data-testid={testid}>{title}</h2>
    {intro && <p className="mt-6 text-base md:text-lg text-slate-400 leading-relaxed max-w-2xl">{intro}</p>}
  </Reveal>
);
